import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { userActions } from '@/redux/actions';
import { useAppDispatch } from '@/redux/hooks';

import { AuthContainer, Button } from '@/components';

interface ConfirmEmailSuccessProps {}

const TOKEN_KEY = 'token';

const ConfirmEmailSuccess: FC<ConfirmEmailSuccessProps> = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    dispatch(userActions.setError(null));

    const token = searchParams.get(TOKEN_KEY);

    if (token) {
      setSearchParams((prev) => {
        prev.delete(TOKEN_KEY);
        return prev;
      });
    }
  }, []);

  const clickHandler = () => {
    navigate('/signin');
  };

  return (
    <AuthContainer
      title={t('translation.confirm_email_success_title')}
      buttons={
        <div>
          <Button size="m" minWidth={240} corner="rect" onClick={clickHandler}>
            {t('translation.ok')}
          </Button>
        </div>
      }
    />
  );
};

export default ConfirmEmailSuccess;
